import React from "react";
import PropTypes from "prop-types";
import {Button, Comment, List, Tag} from "antd";
import useDocumentFirestore from "@web/hooks/useDocumentFirestore";
import Day from "./Day";
import {useDispatch, useSelector} from "react-redux";
import UserAvatar from "./UserAvatar";
import {RepeatIcon, ShoppingCartIcon, UserTodoIcon} from "@web/assets/icons";
import appActions from "@web/redux/app/actions";
import ListItemActive from "./ListItemActive";
import {AgentContext} from "@web/hooks/context";
import {notifyAndTrack} from "./notification";
import {api} from "@web/lib/api";

ActionRunListItem.propTypes = {
  actionRunPath: PropTypes.string.isRequired,
};

function ActionRunListItem(props) {
  console.log("ActionRunListItem:props:", props);
  const dispatch = useDispatch();
  const chatContext = React.useContext(AgentContext);
  const [actionRun, loadingActionRun] = useDocumentFirestore(props.actionRunPath);

  const onClick = () => {
    if (actionRun) {
      chatContext.setAgent({
        ...chatContext.agent,
        agentId: actionRun.action.agentId,
        collectionPath: [props.actionRunPath, "managers", actionRun.action.agentId, "ai-workflow"].join("/"),
      });
      dispatch(appActions.setActiveDetail({
        actionRun,
        // service: service,
        path: props.actionRunPath,
      }));
    } else {
      notifyAndTrack.info("This has not been run", "Action Job not found");
    }
  }

  const runFromHere = () => {
    if (!actionRun) return;
    const pathname = "/workflow/run";
    api.LINE(pathname, {
      workflowPath: actionRun.workflowPath,
      actionRunPath: props.actionRunPath,
    })
    .then(() => notifyAndTrack.info("Started"));
  }


  return <List.Item
    className="relative"
    onClick={onClick}
    extra={
    actionRun?.finished ?
      <Tag className="rounded" color="green">Finished</Tag> :
      actionRun?.started ?
        <Tag className="rounded" color="pink">Started</Tag> :
        <Tag className="rounded muted">Waiting</Tag>
    }>
    <Comment
      avatar={<UserAvatar icon={<UserTodoIcon />} />}
      author={<span className="font-lg">{actionRun?.action?.method.replace(":", " ")}</span>}
      datetime={actionRun?.started ? <Day ts={actionRun?.started?.toMillis()}/> : "Not started"}
      content={<span className="font-lg line-clamp-1">{actionRun?.action?.summary || actionRun?.action?.description}</span>}
      actions={[<div className="space space-center-y">
        <Button ghost size="large" shape="circle"><ShoppingCartIcon className={!!actionRun?.payload ? "" : "muted-icon"} size={18} style={{position: "relative", top: 2}} /></Button>
        {actionRun?.finished ?
          <Button size="large" shape="circle" className="icon-btn" ghost onClick={runFromHere}><RepeatIcon className={!actionRun ? "muted-icon" : ""} /></Button> :
          null}
      </div> ]}
    />
    <ListItemActive path={props.actionRunPath} offset={-20} />
  </List.Item>;
}

export default ActionRunListItem;
